import { string, object, mixed } from 'yup';

import { VipTaskItemStatusesEnum } from '@shared/constants';

export const vipTaskItemValidationSchema = object().shape({
  vipTask: string().trim().required(),
  vipTaskItem: string().trim().required(),
  vipTaskItemStatus: mixed().oneOf(Object.values(VipTaskItemStatusesEnum)).required(),
});
